import { Spacing } from '@persona-id/design-tokens';
import { WrappedFieldProps } from 'redux-form';
import styled from 'styled-components';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import FormError from 'dashboard/components/FormControls/FormError';
import FormWarning from 'dashboard/components/FormControls/FormWarning';
import { IconAlertCircleStyled } from 'dashboard/components/FormControls/FormWarning/FormWarning';
import FormGroup from 'dashboard/layouts/FormLayout/FormGroup';
import Banner from 'design-system/components/Banner/Banner';
import Input, { InputProps } from 'design-system/components/Input';

const DisclaimerIconAlertCircleStyled = styled(IconAlertCircleStyled)`
  min-width: ${Spacing[4]};
`;

const DisclaimerBanner = styled(Banner)`
  padding-top: ${Spacing[2]};
  padding-bottom: ${Spacing[2]};
  margin-top: ${Spacing[2]};
`;

export interface InputFieldProps extends WrappedFieldProps, InputProps {
  label?: string;
  disclaimer?: string;
  disclaimerType?: 'banner' | 'text';
  showError?: boolean;
}

const InputField = ({
  className,
  input,
  meta: { error, submitFailed, dirty, touched },
  autoFocus,
  label,
  placeholder,
  id,
  disclaimer,
  disclaimerType = 'text',
  showError = submitFailed || touched,
  ...passthroughProps
}: InputFieldProps) => {
  const hasError = !!(error && showError);
  const hasDisclaimer = !!(disclaimer && !dirty);

  return (
    <FormGroup className={className}>
      {label && <FormControlLabel htmlFor={id}>{label}</FormControlLabel>}
      <Input
        {...input}
        {...passthroughProps}
        autoFocus={autoFocus}
        hasError={hasError}
        id={id}
        placeholder={placeholder}
      />
      {hasError && <FormError>{error}</FormError>}
      {hasDisclaimer && disclaimerType === 'text' && (
        <FormWarning>
          <DisclaimerIconAlertCircleStyled />
          {disclaimer}
        </FormWarning>
      )}
      {hasDisclaimer && disclaimerType === 'banner' && (
        <DisclaimerBanner variant='warning'>
          <DisclaimerIconAlertCircleStyled />
          {disclaimer}
        </DisclaimerBanner>
      )}
    </FormGroup>
  );
};

export default InputField;
